var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"changelog",attrs:{"title":"Changelogs","icon":"clock"}},[_c('ChangelogList',{ref:"list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }